import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FirebaseContext } from "../context/FirebaseContext";
import { onAuthStateChanged } from "firebase/auth";
import { signOut } from "firebase/auth";
import MenuIcon from "@mui/icons-material/Menu";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";

import { ReactComponent as Logo } from "../../logo.svg";
import "../styles/header.style.scss";

function Header({ setToggleSideBar, toggleSideBar }) {
  const navigate = useNavigate();
  const { auth } = useContext(FirebaseContext);
  const [user, setUser] = useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      }
    });
  });
  function handleLogout(e) {
    e.preventDefault();
    signOut(auth)
      .then(() => {
        // Sign-out successful.
        navigate("/");
        console.log("Signed out successfully");
      })
      .catch((error) => {
        // An error happened.
      });
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className="fixed top-0 left-0 w-full h-14 bg-mainBrandColor z-10">
      <div className="ctn-content h-full flex justify-between items-center">
        <Link
          to="/admin"
          className="flex items-center gap-2 text-secondaryColor no-underline"
        >
          <Logo className="h-[40px] fill-secondaryColor  max-md:h-[30px]" />
          <span className="text-2xl font-medium max-md:text-[1.2em]">
            administration
          </span>
        </Link>
        <Tooltip title="Compte" className="!block max-lg:!hidden">
          <IconButton
            onClick={handleClick}
            size="large"
            sx={{ ml: 2, padding: "0" }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            className="border-2 border-secondaryColor"
          >
            <Avatar
              sx={{
                width: 40,
                height: 40,
                bgcolor: "white",
                color: "black",
                padding: "0",
              }}
              alt={user?.email[0]}
              src={user?.photoURL ?? "./Images/user/profil.jpg"}
            />
          </IconButton>
        </Tooltip>
        <div className="!hidden max-lg:!block">
          <IconButton onClick={() => setToggleSideBar(true)} size="large">
            <MenuIcon
              sx={{
                color: "white",
              }}
            />
          </IconButton>
        </div>
      </div>
      <Menu
        className="!block max-lg:!hidden"
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.137))",
            mt: 2,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 8,
              width: 20,
              height: 20,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleClose}>
          <Avatar
            alt={user?.email[0]}
            src={user?.photoURL ?? "./Images/user/profil.jpg"}
          />{" "}
          Mon Compte
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="medium" />
          </ListItemIcon>
          Paramètre
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="medium" />
          </ListItemIcon>
          Se deconnecter
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Header;
/** <div className="topHeader">
      <nav className="top-bar">
        <div className="logo-left">
          <Link to="/admin">
            <Logo fill={"#293d70"} />
          </Link>
        </div>
        <div className="menu-right">
          <NavLink to="/admin/logout" onClick={handleLogout}>
            <img src={"/Images/icons/logout.png"} alt="disconned" />
          </NavLink>
        </div>
        <div className="menu-icon">
          <input
            className="menu-icon__cheeckbox"
            type="checkbox"
            checked={isOpen}
            onChange={handleCheck}
          />
          <div>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
  </div> */
